// extracted by mini-css-extract-plugin
export default {"root":"Title_root__WaqiI","root_error":"Title_root_error__wO-YJ"};